module.exports = __webpack_public_path__ + "media/components/star-rating/static/yellow/0.5-a8fc226b66e237ba29d60e6f9fb90416.svg";